<template>
  <div>
	<div class="data43"> 
		<div class="data43Til">超高精度·打破像素桎梏</div>
		<div class="data43TilTwo">精准洞悉病灶细节</div>
		<div class="data43Cen">
			搭载全新图像算法，通过光学放大保留更多有效像素，使放大效果更佳
			临床图像纤毫毕现，全方位还原人体腔道真实细节
		</div>
		<div class="data43Img">
			<img src="@/assets/content/fd100img.png" />
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.data43{
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 150px;
	.data43Til{
		font-size: 45px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #000000;
		margin-bottom: 65px;
	}
	.data43TilTwo{
		font-size: 26px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #000000;
		margin-bottom: 36px;
	}
	.data43Cen{
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 300;
		color: #000000;
		margin-bottom: 65px;
	}
	.data43Img{
		width: 1200px;
		height: 600px;
		img{
			width: 100%;
			height: 100%;
		}
		video{
			width: 100%;
			height: 100%;
		}
	}
}
</style>
